<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard>
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-semibold leading-6 text-gray-900">
                        Delete Segment
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" @click="dismiss()" />
                </div>
            </template>
            <p class="text-sm text-gray-500">
                Are you sure you want to delete <span class="font-medium text-gray-900">{{ segment?.name }}</span>?
                This action cannot be undone.
            </p>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" color="white">Cancel</UButton>
                    <UButton @click="onDelete" :loading="loading" color="red">Delete</UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { BroadcastSegment } from '~/types/segment'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    segment?: BroadcastSegment
}>()

const loading = ref(false)

async function onDelete() {
    if (!props.segment) return

    loading.value = true

    try {
        await $fetch(`/api/segments/${props.segment.id}`, { method: 'DELETE' })
        dismiss(true)
    } catch (error) {
        console.error('Delete error:', error)
    }

    loading.value = false
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)
    if (reload) {
        emit('reload', true)
    }
}
</script>
